// src/components/stats/RecentFormStrip.jsx -- presentational per-game-rate strip.
// Receives the computed strip (array of {key,label,value,sampleCount}) or null,
// and an honest caption. Per-game rates only, never season totals (§7/§8/§A1).
// A null strip means the role has no games collected yet. Spec §C4.

export default function RecentFormStrip({ strip, caption }) {
  if (!strip) {
    return (
      <div style={{ color: '#94a3b8', fontSize: 13, padding: '8px 0' }}>
        No games in this role collected yet.
      </div>
    );
  }
  return (
    <div style={{ padding: '4px 0 8px' }}>
      <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
        {strip.map((m) => (
          <div
            key={m.key}
            style={{
              flex: '1 1 0', minWidth: 72, background: '#0b1626', border: '1px solid #1e293b',
              borderRadius: 12, padding: '10px 12px', textAlign: 'center',
            }}
          >
            <div style={{ fontSize: 20, fontWeight: 800, color: '#fff' }}>
              {m.value === null ? '—' : m.value.toFixed(1)}
            </div>
            <div style={{ fontSize: 10, fontWeight: 700, color: '#94a3b8', marginTop: 2 }}>{m.key}</div>
          </div>
        ))}
      </div>
      {caption && (
        <div style={{ fontSize: 11, color: '#64748b', marginTop: 8 }} title="collected games, not official season totals">
          ⓘ {caption}
        </div>
      )}
    </div>
  );
}
